"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WAREHOUSE = void 0;
var WAREHOUSE = {
  BUTTON__SELECT: 'inventoryAdditionWarehouse-button-selectWarehouse',
  INPUT__BATCH_CODE: 'inventoryAdditionWarehouse-input-batchCode',
  INPUT__DATE_PICKER: 'inventoryAdditionWarehouse-input-expiryDate'
};
exports.WAREHOUSE = WAREHOUSE;